import { cn } from '@/lib/utils';

// One application-wide status vocabulary; stored values are mapped, never changed.
const TONES = {
  'Draft': 'bg-muted text-muted-foreground',
  'Not Started': 'bg-muted text-muted-foreground',
  'In Progress': 'bg-primary/10 text-primary',
  'Awaiting Client': 'bg-warning/15 text-warning',
  'Awaiting Review': 'bg-brand-accent/10 text-brand-accent',
  'Ready for Lodgement': 'bg-primary/10 text-primary',
  'Lodged': 'bg-success/15 text-success',
  'Completed': 'bg-success/15 text-success',
  'Overdue': 'bg-destructive/10 text-destructive',
  'On Hold': 'bg-secondary text-secondary-foreground',
};

const MAP = {
  draft: 'Draft', lead: 'Draft',
  todo: 'Not Started', not_started: 'Not Started', task_created: 'Not Started', pending: 'Not Started',
  in_progress: 'In Progress', preparation: 'In Progress', bookkeeping: 'In Progress', gathering_data: 'In Progress', documents_received: 'In Progress',
  waiting_client: 'Awaiting Client', awaiting_client: 'Awaiting Client', awaiting_docs: 'Awaiting Client', awaiting_documents: 'Awaiting Client',
  waiting_for_client: 'Awaiting Client', awaiting_client_approval: 'Awaiting Client', ready_for_client_approval: 'Awaiting Client', needs_clarification: 'Awaiting Client',
  in_review: 'Awaiting Review', review: 'Awaiting Review', internal_review: 'Awaiting Review', accountant_review: 'Awaiting Review', partner_review: 'Awaiting Review', ai_review: 'Awaiting Review',
  ready_for_lodgment: 'Ready for Lodgement', ready_to_lodge: 'Ready for Lodgement',
  lodged: 'Lodged', reported: 'Lodged', assessed: 'Lodged',
  done: 'Completed', completed: 'Completed', paid: 'Completed', accepted: 'Completed',
  overdue: 'Overdue',
  on_hold: 'On Hold', archived: 'On Hold', inactive: 'On Hold',
};

export const STATUS_VOCAB = Object.keys(TONES);
const humanise = (v) => String(v || '').replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
export const statusLabel = (value) => MAP[String(value || '').toLowerCase()] || (TONES[value] ? value : humanise(value));

export const StatusPill = ({ status, overdue = false, className, ...rest }) => {
  const label = overdue ? 'Overdue' : statusLabel(status);
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap', TONES[label] || 'bg-muted text-muted-foreground', className)}
      data-status={status} {...rest}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" aria-hidden="true" />{label}
    </span>
  );
};
